module.exports = __webpack_public_path__ + "static/media/creativ0.511bab8f.jpg";